import { render, staticRenderFns } from "./AppPsi.vue?vue&type=template&id=09961876&scoped=true"
import script from "./AppPsi.vue?vue&type=script&lang=js"
export * from "./AppPsi.vue?vue&type=script&lang=js"
import style0 from "./AppPsi.vue?vue&type=style&index=0&id=09961876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09961876",
  null
  
)

export default component.exports